export const supportedColumnsNoneStr = `[
    person,
    status,
    numbers,
    date,
    hour,
    email,
    phone,
    dropdown,
    text,
    rating,
    link,
    long_text,
    timeline,
    people, 
    file,
    checkbox,
    board_relation,
    location,
    tags,
    doc
]`;

export enum SupportedColumnTypes {
  PERSON = "person",
  STATUS = "status",
  NUMBERS = "numbers",
  DATE = "date",
  HOUR = "hour",
  EMAIL = "email",
  PHONE = "phone",
  DROPDOWN = "dropdown",
  TEXT = "text",
  RATING = "rating",
  LINK = "link",
  LONG_TEXT = "long_text",
  TIMELINE = "timeline",
  PEOPLE = "people",
  FILE = "file",
  CHECKBOX = "checkbox",
  BOARD_RELATION = "board_relation",
  LOCATION = "location",
  TAGS = "tags",
  DOC = "doc",
}

export const supportedColumnTypesArray = Object.values(SupportedColumnTypes);
